import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import {
  CirclePlusOutline,
  CircleCross,
  CheckBoxUnchecked,
  CheckBoxChecked,
} from 'AppSrc/core/components/common/svg-icons';
import { SVGForFileType } from 'AppSrc/core/components/utility/svg-for-file-type';

const oneMb = 1000000;

class DropzoneArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveringFile: false,
      errors: [],
      bigfile: false,
      checkboxClicked: false,
      RemedyLinkPresentState: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.dropzoneRef = React.createRef();
    this.onFileEnter = this.onFileEnter.bind(this);
    this.onFileExit = this.onFileExit.bind(this);
    this.onDropRejected = this.onDropRejected.bind(this);
    this.MoreSize = this.MoreSize.bind(this);
  }

  componentDidMount() {
    this.props.ButtonCheck(false);
    if (this.props.RemedyLinkPresent) {
      this.setState({ RemedyLinkPresentState: true, checkboxClicked: true });
    }
  }

  onFileEnter() {
    this.setState({
      hoveringFile: true,
    });
  }

  onFileExit() {
    this.setState({
      hoveringFile: false,
    });
  }

  onDropRejected(files) {

    const file = files[0];

    const {
      size,
      name,
    } = file;

    const {
      acceptedFileTypes,
      maxSize,
    } = this.props;

    const errors = [];

    const fileExtension = name.split('.').pop();

    // to catch an error where the file's name is "myFirstFile" as opposed to "myFirstFile.pdf"
    const noFileExtensionError = acceptedFileTypes && !fileExtension;

    const fileTypeIsAccepted = acceptedFileTypes.includes(`.${fileExtension}`);


    if (noFileExtensionError || !fileTypeIsAccepted) {
      errors.push('Format not supported');
    }


    const maxSizeInBytes = maxSize * oneMb;

    const tooBig = size > maxSizeInBytes;

    if (tooBig) {
      errors.push(`File too big, maximum ${maxSize}MB allowed`);
    }


    this.setState({
      hoveringFile: false,
      errors: [
        ...errors,
      ],
    });
  }

  handleChange(acceptedFiles) {
    let errors = [];
    const file = acceptedFiles[0];
    this.props.onFileAdded(file);
    const fileSize = Math.round(file.size / 1024);
    if (fileSize > 3500) {
      errors.push('File is big, maximum 3.5MB allowed');
      this.setState({
        hoveringFile: false,
        errors: [
          ...errors,
        ],
        bigfile: true,
      });
      this.handleDelete();
    }
    else {
      errors = [];
      this.setState({
        hoveringFile: true,
        errors: [
          ...errors,
        ],
        bigfile: false,
      });
    }
  }

  handleDelete() {
    this.props.onFileRemoved();
    this.setState({
      hoveringFile: false,
    });
  }

  MoreSize() {
    if (this.state.RemedyLinkPresentState) {
      this.setState({ checkboxClicked: true, RemedyLinkPresentState: false });
    }
    this.setState((prevState) => ({ checkboxClicked: !prevState.checkboxClicked }));
    if (this.state.checkboxClicked) {
      this.props.ButtonCheck(false);
    }
    else {
      this.props.ButtonCheck(true);
    }
  }


  render() {
    const {
      currentFile,
      disabled,
      acceptedFileTypes,
      maxSize,
    } = this.props;
    const {
      hoveringFile,
      errors,
    } = this.state;
    // const network = window.localStorage.getItem('networks');
    // const link = network === 'fixed' ? 'http://ukrem06vr.ad.plc.cwintra.com:8080/arsys/ ' : 'https://ukmbremwt.dc-dublin.de/arsys ';
    const maxSizeInBytes = maxSize * oneMb;
    const className = `v-f-field-type v-f-dropzone${this.state.RemedyLinkPresentState || this.state.checkboxClicked ? ' v-f-dropzone-disabled' : ''}`;
    if (currentFile && (!this.state.bigfile)) {
      const {
        fileName,
      } = currentFile;

      return (
        <div className={currentFile ? className : ''}>
          <p>
            Please Note: attachments above 3.5MB cannot be uploaded through the ACE Portal at the current time, and will need to added directly in Remedy
            <br />
            DO NOT UPLOAD FILES
            {' < '}
            3.5MB IN REMEDY
          </p>
          <button type="button" className="file-checkbox checkbox-container v-f-dropzone-disabled" onClick={this.MoreSize}>
            { this.state.checkboxClicked ? <CheckBoxChecked /> : <CheckBoxUnchecked /> }
            <div className="svg-container file-checkbox checkbox-container attachement">
              Large file, attachment to be added directly in Remedy
            </div>
          </button>
          {/* <p className="checkbox-container"><a href={link} className="remedy-link v-f-dropzone-disabled" target="_blank" rel="noopener noreferrer">Remedy</a></p> */}
          <div
            className="dropzone-area dropzone-area-file"
          >
            <div className="dropzone-area-file-inner">
              <div className="file-svg-wrapper">
                { this.state.CheckBoxChecked ? '' : <SVGForFileType fileName={fileName} /> }
              </div>
              <p>{fileName}</p>
              <div className="cancle-svg-wrapper">
                <button
                  type="button"
                  onClick={this.handleDelete}
                >
                  <CircleCross />
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <p>
          Please Note: attachments above 3.5MB cannot be uploaded through the ACE Portal at the current time, and will need to added directly in Remedy
          <br />
          DO NOT UPLOAD FILES
          {' < '}
          3.5MB IN REMEDY
        </p>
        <button type="button" className="file-checkbox checkbox-container" onClick={this.MoreSize}>
          { this.state.checkboxClicked ? <CheckBoxChecked /> : <CheckBoxUnchecked /> }
          <div className="svg-container file-checkbox checkbox-container attachement">
            Large file, attachment to be added directly in Remedy
          </div>
        </button>
        {/* <p className="checkbox-container"><a href={link} className="remedy-link" target="_blank" rel="noopener noreferrer">Remedy</a></p> */}
        <div className={className}>
          <Dropzone
            ref={this.dropzoneRef}
            multiple={false} // some of the files methods would need modifying if this ever gets set to true
            onDropAccepted={this.handleChange}
            disabled={disabled}
            accept={acceptedFileTypes}
            onDragEnter={this.onFileEnter}
            onDragLeave={this.onFileExit}
            onDropRejected={this.onDropRejected}
            maxSize={maxSizeInBytes}
          >
            {({
              getRootProps,
              getInputProps,
              isDragAccept,
              isDragReject,
            }) => (
              <div
                /* Disabling props spreading rule because this is just how you use the dropzone library */
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...getRootProps()}
                className={`dropzone-area dropzone-area-${hoveringFile ? 'hovering' : ''}`}
              >
                <div className="svg-wrapper-container">
                  <div className="svg-wrapper">
                    <CirclePlusOutline />
                  </div>
                </div>

                <div className="instructions">
                  <h2>Drop your file here</h2>
                  <p className="instructions-text">
                    or browse your folders
                  </p>
                </div>
                <input

                  /* Disabling props spreading rule because this is just how you use the dropzone library */
                  /* eslint-disable-next-line react/jsx-props-no-spreading */
                  {...getInputProps()}
                />
                {
                  errors.length > 0 && (
                    <span className="file-error-message">
                      {errors.join('. ')}
                    </span>
                  )
                }
              </div>
            )}
          </Dropzone>
        </div>
      </div>
    );
  }
}

DropzoneArea.propTypes = {
  onFileAdded: PropTypes.func,
  onFileRemoved: PropTypes.func,
  // PropTypes.file doesn't exist :shrugs:
  // eslint-disable-next-line react/forbid-prop-types
  currentFile: PropTypes.object,
  disabled: PropTypes.bool,
  acceptedFileTypes: PropTypes.oneOfType([
    PropTypes.string, PropTypes.arrayOf(PropTypes.string),
  ]),
  maxSize: PropTypes.number,
  CrqID: PropTypes.string,
  ButtonCheck: PropTypes.func,
  RemedyLinkPresent: PropTypes.bool,
};



export { DropzoneArea };
